/**
 * Component: Scroll-container resolution for the Browse surface
 * SpecReferenceID: WIDGET-V1
 * Requirements: WIDGET-V1-R13, WIDGET-V1-R29
 *
 * Shared by the back-to-top control (AB#4647) and the Contents
 * current-section tracking (R29), which both need to know which
 * element actually scrolls the guideline: the document, or a host
 * element with its own ``overflow-y: auto`` chrome.
 *
 * Risk Links: R7
 * FMEA Links: FM7
 */

/**
 * AB#4647: walk up from ``el`` to the nearest ancestor that is
 * actually scrollable on the Y axis. Returns ``null`` when no
 * such ancestor exists (i.e. the document scrolls). The widget
 * may be embedded either where the document scrolls (test-site,
 * portal page) or inside a host element with its own
 * ``overflow-y: auto`` chrome; resolving the scroller this way
 * lets a single animation target the right container instead of
 * ``scrollIntoView`` animating every scrollable ancestor at
 * once.
 */
export function findScrollContainer(
  el: Element | null,
): HTMLElement | null {
  if (!el) return null;
  if (typeof window === 'undefined') return null;
  let node = el.parentElement;
  while (node && node !== document.body && node !== document.documentElement) {
    const style = window.getComputedStyle(node);
    const overflowY = style.overflowY;
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }
    node = node.parentElement;
  }
  return null;
}
